import React from "react";
import { useMutation } from "@apollo/client";
import mutations from "Shared/mutations";
import {
  GenerateRewardsReportMutation,
  GenerateRewardsReportMutationVariables,
} from "generated/graphql";
import { DPButton } from "Components/DP";
import { errorToast } from "Modules/DPToast";
import { downloadS3File } from "Modules/S3Downloads";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";

export const RewardsDownloadButton = () => {
  const [generateRewardsReport] = useMutation<
    GenerateRewardsReportMutation,
    GenerateRewardsReportMutationVariables
  >(mutations.GENERATE_REWARDS_REPORT);

  const onDownloadClick = async () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.RewardDownloadClicked,
    });
    try {
      const { data } = await generateRewardsReport();

      downloadS3File(data!.generateRewardsReportUrl.reportUrl);
    } catch (err) {
      errorToast("Something went wrong. Please, try again later.");
    }
  };

  return (
    <DPButton onClick={onDownloadClick} size="large">
      Download
    </DPButton>
  );
};
